export const Field = ({ label, id, error, required, children, className = "" }) => (
  <div className={className}>
    <label htmlFor={id} className="mb-2 block text-xs font-medium uppercase tracking-[0.18em] text-current/70">
      {label}{required && <span className="text-gold"> *</span>}
    </label>
    {children}
    {error && <p className="mt-1.5 text-xs text-red-600" data-testid={`${id}-error`} role="alert">{error}</p>}
  </div>
);

export const Input = ({ id, dark, ...props }) => (
  <input id={id} name={id} data-testid={`${id}-input`} className={dark ? "field-dark" : "field"} {...props} />
);

export const Select = ({ id, dark, options, placeholder, ...props }) => (
  <select id={id} name={id} data-testid={`${id}-select`} className={`${dark ? "field-dark" : "field"} appearance-none`} {...props}>
    {placeholder && <option value="">{placeholder}</option>}
    {options.map((o) => <option key={o.value ?? o} value={o.value ?? o} className="text-charcoal">{o.label ?? o}</option>)}
  </select>
);

export const Textarea = ({ id, dark, ...props }) => (
  <textarea id={id} name={id} rows={4} data-testid={`${id}-textarea`} className={dark ? "field-dark" : "field"} {...props} />
);

export const Honeypot = ({ value, onChange }) => (
  <div className="absolute -left-[9999px] top-auto h-px w-px overflow-hidden" aria-hidden="true">
    <label htmlFor="website">Website</label>
    <input id="website" name="website" type="text" tabIndex={-1} autoComplete="off" value={value} onChange={onChange} data-testid="honeypot-website" />
  </div>
);

export const SuccessState = ({ title = "Thank you.", text, onReset, dark, testId = "form-success" }) => (
  <div className={`rounded-sm border p-8 text-center ${dark ? "border-gold/40 bg-emerald-900/40" : "border-gold/40 bg-white"}`} data-testid={testId}>
    <span className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full border border-gold text-gold">✓</span>
    <h3 className={`h3 ${dark ? "!text-ivory" : ""}`}>{title}</h3>
    <p className={`mt-3 text-sm leading-relaxed ${dark ? "text-ivory/75" : "text-charcoal/70"}`}>{text}</p>
    {onReset && <button type="button" onClick={onReset} className="mt-6 text-xs uppercase tracking-[0.2em] text-gold-600 hover:text-gold" data-testid="form-reset-button">Submit another</button>}
  </div>
);

export const SubmitButton = ({ loading, children, testId, className = "btn-primary" }) => (
  <button type="submit" disabled={loading} className={`${className} w-full sm:w-auto min-w-[200px]`} data-testid={testId}>
    {loading ? <span className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" /> : null}
    {loading ? "Sending…" : children}
  </button>
);
